module.exports = __webpack_public_path__ + "static/media/smart-tv.090a4356.png";